import { useGetPath } from '@hooks/interview/useGetPath';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useBrowser } from '../utils/useBrowser';
import { useException } from '../utils/useException';

export function useDeviceState() {
  const { browserHelper } = useBrowser();
  const navigate = useNavigate();
  const { rootPath } = useGetPath();
  const { withLogger } = useException();

  const checkDeviceStatus = async () => {
    try {
      await browserHelper.getBrowserMedia({ audio: true, video: true });
    } catch (error) {
      withLogger(error);
      navigate(rootPath.CHECK_DEVICE, { replace: true });
    }
  };

  useEffect(() => {
    checkDeviceStatus();
  }, []);
}
